import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";
import dayjs from "dayjs";
import DateTimeUtil from "../../../../utils/common/DateTimeUtil";

const warehouseMaterialOrgRestUrl = ordersServicesPath + '/organizations/materials-warehouse'
const warehouseMaterialRestUrl = ordersServicesPath + '/user/materials-warehouse'

export default class MaterialWarehouseService {

    static async getAllByMaterialId(id) {
        return axios.get(warehouseMaterialOrgRestUrl + '/material/' + id);
    }

    static async getAllInStock() {
        let startInStock = dayjs(Date.now());
        let convertToJavaDateTime = DateTimeUtil.convertToJavaDateTime(startInStock);
        return axios.get(warehouseMaterialOrgRestUrl + '/in-stock?localDateTime=' + convertToJavaDateTime);
    }

    static async getAllInWork() {
        let startInStock = dayjs(Date.now());
        let convertToJavaDateTime = DateTimeUtil.convertToJavaDateTime(startInStock);
        return axios.get(warehouseMaterialOrgRestUrl + '/in-work?localDateTime=' + convertToJavaDateTime);
    }

    static async getAllBalanceSheet(start, end, skipZero) {
        return axios.get(`${warehouseMaterialOrgRestUrl}/balance-sheet?start=${start}&end=${end}&skipZero=${skipZero}`);
    }

    static async getAllByMaterialIdArchive(id) {
        return axios.get(warehouseMaterialOrgRestUrl + '/material/' + id + '/archive');
    }
    static async getAllByMaterialIdChildren(id) {
        return axios.get(warehouseMaterialOrgRestUrl + '/material/' + id + '/children');
    }

    static async getAllByMaterialEstimateUnitId(materialEstimateUnitId) {
        return axios.get(warehouseMaterialOrgRestUrl + '/by-material-estimate-unit-id'
            + '?materialEstimateUnitId=' + materialEstimateUnitId);
    }

    static async getAllByMaterialIdForCuttingMap(id) {
        return axios.get(warehouseMaterialOrgRestUrl + '/' + id + '/for-cutting-map/');
    }

    static async getByMaterialId(materialId, country) {
        return axios.get(warehouseMaterialRestUrl + '/by-material-id' + '?materialId=' + materialId + "&country=" + country);
    }

    static async getAllByIssuingEdgeId(issuingEdgeId) {
        return axios.get(warehouseMaterialOrgRestUrl + '/by-issuing-edge-id' + '?issuingEdgeId=' + issuingEdgeId);
    }

    static async createPlanned(data, nameMaterial, supplierMaterialId) {
        return await axios.post(warehouseMaterialOrgRestUrl
            + '/create-planned' + "?nameMaterial=" + nameMaterial
            + "&supplierMaterialId=" + supplierMaterialId
            , JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async confirmedOrNotConfirmedCutOff(id, confirmedAfterCutting, note) {
        return await axios.post(warehouseMaterialOrgRestUrl + '/' + id + '/set-confirmed' + "?confirmedAfterCutting="
            + confirmedAfterCutting + "&note=" + note, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setPriceCloud(id, currencyId, price) {
        return await axios.post(warehouseMaterialOrgRestUrl + '/' + id + '/set-price-cloud' + "?currencyId="
            + currencyId + "&price=" + price, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(warehouseMaterialOrgRestUrl + '/' + id + '/delete-price-cloud', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deletePlanned(id) {
        await axios.delete(warehouseMaterialOrgRestUrl + '/delete-planned/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendToArchive(id) {
        await axios.patch(warehouseMaterialOrgRestUrl + "/" + id + '/send-to-archive', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendToIssue(id, comment) {
        await axios.patch(warehouseMaterialOrgRestUrl + '/set-to-issue?id=' + id + "&comment=" + comment, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateNote(id, note) {
        return await axios.post(warehouseMaterialOrgRestUrl + '/' + id + '/update-note-cut-off', JSON.stringify({note: note}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveNote(id, note) {
        return await axios.patch(warehouseMaterialOrgRestUrl + '/' + id + '/note', note ?? '', {
            headers: {
                'Content-Type': 'text/plain;charset=UTF-8'
            },
            transformResponse: [(data) => (data === '' || data == null ? null : data)],
        });
    }

    static async updateCutOff(data) {
        return await axios.post(warehouseMaterialOrgRestUrl + '/update-cut-off', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCutOffsByWorkingCuttingMapId(workingCuttingMapId) {
        return axios.get(warehouseMaterialOrgRestUrl + '/get-all-cut-offs-by-working-cutting-map-id'
            + '?workingCuttingMapId=' + workingCuttingMapId);
    }

    static async sendToAllArchive() {
        await axios.patch(warehouseMaterialOrgRestUrl + '/send-to-all-archive',
            [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}